import * as R from "ramda";

export const getAnswerForField = (record, field) =>
  R.path(["answers", R.path(["key"], field)], record);

export const getErrors = R.propOr({}, "errors");
export const getErrorForField = (record, field) => R.path(["errors", field.key], record);

const pageIdentifier = (...p) => ["page", ...p].join(":");

export const getAllPageIdentifiers = (context) => {
  const pages = R.propOr({}, "user_pages")(context);
  return R.reduce(
    (memo, page) => [
      ...memo,
      pageIdentifier(page),
      ...R.map((p) => pageIdentifier(page, p), R.propOr([], "order")(pages[page])),
    ],
    [],
    R.keys(pages),
  );
};

export const getFieldIdents = (context) =>
  getFieldIdentsForPages(R.values(R.prop("user_pages", context)));

const getFieldIdentsFromEntity = (entity, dataKey) =>
  R.chain((key) => R.path([dataKey, key])(entity))(entity.order);

export const getFieldIdentsForPages = (...pages) => {
  const activeFieldIdents = R.reduce((fieldIDs, entity) => {
    switch (entity.type) {
      case "FieldList": {
        return R.concat(fieldIDs, entity.list);
      }
      case "PageList": {
        return R.concat(fieldIDs, getFieldIdentsFromEntity(entity, "pages"));
      }
      case "SectionList": {
        return R.concat(fieldIDs, getFieldIdentsFromEntity(entity, "sections"));
      }
      default: {
        if (R.is(Object, entity)) {
          const nestedFieldIds = R.pipe(
            R.toPairs,
            R.chain(([_key, _value]) => getFieldIdentsForPages(_value)),
          )(entity);

          return R.concat(fieldIDs, nestedFieldIds);
        }
        return fieldIDs;
      }
    }
  }, [])(pages);

  return R.uniq(activeFieldIdents);
};
